// Fuente única de las personas de Bison (spec 012). La consumen /nosotros (tarjetas), las fichas
// /autores/<slug>/, el schema (nodos Person con señales E-E-A-T), los artículos y notas (autor por
// slug), llms*.txt y el worker MCP. Verificar todo contra fuente primaria; no inventar.
//
// - `author: true` → tiene ficha en /autores/<slug>/ (firma artículos o notas). El @id de su Person
//   es `<ficha>#person`; el de quien no firma, `/nosotros/#<slug>`.
// - `founder: true` → va en Organization.founder. `advisor: true` → affiliation (no worksFor) en el schema.
// - `role` es la línea corta de la tarjeta y de la firma; `jobTitle`, el cargo del schema; `title`, el
//   nombre completo del cargo (ficha).
// - `bio` es la de la tarjeta (1–2 frases); `description`, la larga de la ficha y del schema.

const UC = { name: 'Pontificia Universidad Católica de Chile', sameAs: 'https://www.uc.cl' };

export const PERSONAS = [
  {
    slug: 'matias-tapia',
    name: 'Matías Tapia',
    firstName: 'Matías',
    lastName: 'Tapia',
    initials: 'MT',
    author: true,
    founder: true,
    role: 'CEO · Co-founder',
    jobTitle: 'CEO & Co-founder',
    title: 'Chief Executive Officer',
    credential: 'Ingeniero TI · PUC',
    image: '/assets/people/matias-tapia.webp',
    avatar: '/assets/people/matias-tapia-avatar.png',
    linkedin: 'https://www.linkedin.com/in/mgtapia/',
    bio: 'Emprendedor serial: 8 empresas, 3 activas y 1 exit. Construye la estrategia y el negocio de Bison para convertir visibilidad en ventas.',
    description:
      'Emprendedor serial e ingeniero de la PUC. Cofundador de Tucar, BondUP, Monus, Cytech, Albarrio y M2B Technologies; actualmente director de Tucar. En Go PlanBe acompañó a clientes en el levantamiento y crecimiento de sus empresas. En Bison construye la estrategia y el negocio para convertir visibilidad en ventas.',
    knowsAbout: ['Answer Engine Optimization', 'estrategia de producto', 'SaaS', 'emprendimiento'],
    alumniOf: [UC],
    credentials: [
      { category: 'degree', name: 'Ingeniero Civil en Tecnologías Industriales y de Sistemas de Información' },
    ],
    sameAs: ['https://www.linkedin.com/in/mgtapia/', 'https://www.crunchbase.com/person/matías-tapia'],
  },
  {
    slug: 'matias-ramirez',
    name: 'Matías Ramírez',
    firstName: 'Matías',
    lastName: 'Ramírez',
    initials: 'MR',
    author: true,
    founder: true,
    role: 'CTO · Co-founder',
    jobTitle: 'CTO & Co-founder',
    title: 'Chief Technology Officer',
    credential: 'Ingeniero Eléctrico · PUC',
    image: '/assets/people/matias-ramirez.webp',
    avatar: '/assets/people/matias-ramirez-avatar.png',
    linkedin: 'https://www.linkedin.com/in/ramirezmatias/',
    bio: 'Ingeniero de datos y fundador de Vlitzer y Suncast. Construye el motor técnico de Bison que vuelve el ruido de la IA en señal medible.',
    description:
      'Ingeniero eléctrico y electrónico de la PUC, especializado en data engineering y computer vision. Cofundador de Vlitzer y Suncast; ha trabajado como Data Engineer en Treeswift (EE.UU.) aplicando deep learning a datos LiDAR y satelitales. Reconocido en el NASA Space Apps Challenge (2019) y el Agro Hackathon 2020 (IRADE). En Bison construye el motor técnico que vuelve el ruido de la IA en señal medible.',
    knowsAbout: ['data engineering', 'MLOps', 'data science', 'computer vision', 'deep learning'],
    award: ['NASA Space Apps Challenge (2019)', 'Agro Hackathon 2020 — IRADE'],
    alumniOf: [UC],
    credentials: [
      { category: 'degree', name: 'Ingeniería Eléctrica y Electrónica' },
      {
        category: 'certificate',
        name: 'Certificaciones en Cloud Engineering y Data Engineering (Google Cloud / Qwiklabs, Coursera)',
      },
    ],
    sameAs: ['https://www.linkedin.com/in/ramirezmatias/'],
  },
  {
    // Datos de su perfil de LinkedIn (experiencia y educación), revisados con el usuario el 2026-10-12.
    slug: 'felipe-diaz',
    name: 'Felipe Díaz',
    firstName: 'Felipe',
    lastName: 'Díaz',
    initials: 'FD',
    author: true,
    founder: true,
    role: 'CCO · Co-founder',
    jobTitle: 'CCO & Co-founder',
    title: 'Chief Commercial Officer',
    credential: 'Ing. Comercial · MBA UChile',
    image: '/assets/people/felipe-diaz.webp',
    avatar: '/assets/people/felipe-diaz-avatar.png',
    linkedin: 'https://www.linkedin.com/in/felipe-diaz-rettig/',
    bio: 'Ing. Comercial y MBA. Más de 10 años liderando equipos comerciales y conectando tecnología con oportunidades de negocio.',
    description:
      'Ingeniero Comercial y MBA de la Universidad de Chile, con más de 10 años de experiencia en la industria tecnológica B2B. Ha desarrollado su carrera en empresas como Inexlink, Beetrack y Llegó, liderando estrategias comerciales, equipos de ventas y el desarrollo de nuevos negocios.\n\nActualmente es Gerente Comercial de Biwiser Group y cofundador de Bison Agents, donde combina su experiencia comercial con las nuevas oportunidades que ofrece la inteligencia artificial para ayudar a las empresas a fortalecer su posicionamiento en motores de IA, ganar visibilidad y generar nuevas oportunidades de negocio.',
    knowsAbout: ['ventas B2B', 'desarrollo de negocios', 'gestión comercial', 'SaaS', 'logística de última milla', 'HubSpot'],
    alumniOf: [
      { name: 'Universidad Andrés Bello', sameAs: 'https://www.unab.cl' },
      { name: 'Universidad de Chile', sameAs: 'https://uchile.cl' },
    ],
    credentials: [
      { category: 'degree', name: 'Ingeniería Comercial' },
      { category: 'degree', name: 'Magíster en Gestión de Empresas y Marketing' },
      { category: 'degree', name: 'Master of Business Administration (MBA)' },
    ],
    sameAs: ['https://www.linkedin.com/in/felipe-diaz-rettig/'],
  },
  {
    // Asesor (no cofundador desde el 2026-10-12): conserva sus señales E-E-A-T; no firma, no tiene ficha.
    slug: 'felipe-concha',
    name: 'Felipe Concha',
    firstName: 'Felipe',
    lastName: 'Concha',
    initials: 'FC',
    author: false,
    founder: false,
    advisor: true,
    role: 'Advisor',
    jobTitle: 'Advisor',
    credential: 'Ingeniero Estructural · PUC',
    image: '/assets/people/felipe-concha.webp',
    linkedin: 'https://www.linkedin.com/in/felipe-concha-rojas/',
    bio: 'PhD en IA y fundador de Cytech y BuildaLab. Aporta el rigor científico de Bison que vuelve los datos complejos en decisiones estratégicas.',
    description:
      'PhD en Inteligencia Artificial y magíster en Mecánica Computacional (PUC), ingeniero estructural y fundador de Cytech y BuildaLab. Autor de cinco publicaciones peer-reviewed en mecánica computacional, biomecánica y optimización —en Journal of the Mechanics and Physics of Solids, Engineering with Computers y Computer Methods in Applied Mechanics and Engineering—, incluyendo «Multi-fidelity Bayesian optimization of shear-wall building costs» (2025). Mejor Tesis de su departamento (2017) y 1er lugar en Innova Summit 2025 (construcción inteligente). Aporta el rigor científico de Bison que vuelve los datos complejos en decisiones estratégicas.',
    knowsAbout: ['inteligencia artificial', 'machine learning', 'modelos generativos', 'mecánica computacional', 'optimización estructural', 'optimización bayesiana'],
    alumniOf: [UC],
    credentials: [
      { category: 'degree', name: 'Doctorado en Inteligencia Artificial' },
      { category: 'degree', name: 'Magíster en Mecánica Computacional' },
      { category: 'degree', name: 'Ingeniero Estructural' },
    ],
    sameAs: [
      'https://www.linkedin.com/in/felipe-concha-rojas/',
      'https://scholar.google.com/citations?user=3SVK_9sAAAAJ',
      'https://investigadores.anid.cl/es/public_search/researcher?id=45109',
    ],
  },
];

export const AUTORES = PERSONAS.filter((p) => p.author);
export const FUNDADORES = PERSONAS.filter((p) => p.founder);

export const personaPorSlug = (slug) => PERSONAS.find((p) => p.slug === slug);

// Ruta de la ficha (con la barra final del sitio) o, si no firma, el ancla de /nosotros.
export const personaPath = (p) => (p.author ? `/autores/${p.slug}/` : `/nosotros/#${p.slug}`);
export const personaId = (base, p) => (p.author ? `${base}/autores/${p.slug}/#person` : `${base}/nosotros/#${p.slug}`);

// Los artículos y notas declaran `author: '<slug>'`; `articles.js` y `actualidad.js` lo resuelven con
// esto al objeto que usan las vistas (nombre, iniciales, avatar, cargo y URL de la ficha).
export function resolverAutor(slug) {
  const p = personaPorSlug(slug);
  if (!p) throw new Error(`Autor desconocido: «${slug}» (agrégalo a src/libs/content/personas.js)`);
  return { slug: p.slug, name: p.name, initials: p.initials, role: p.role, avatar: p.avatar, url: personaPath(p) };
}
